// -------------------
// FORMAT MONEY VALUE
// -------------------
/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format = window.Shopify.currencyFormat) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    let moneyFormat = '€{{amount_with_comma_separator}}';
    let value = '';
    const placeholderRegex = /\{{([^}]+)\}}/g;
    const inputString = format || moneyFormat;
    let formatString = inputString;

    function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ',',
        decimal = '.'
    ) {
        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            `$1${thousands}`
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    let match;
    while (match = placeholderRegex.exec(inputString)) {
        switch (match[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            case 'currency':
                value = window.Shopify.currency.active; 
                break;
        }

        formatString = formatString.replace(match[0], value);
    };

    return formatString;
}

/**
 * data-variant-link — preselección de variante sin URL param en el href.
 * wip/seo-brain/variant-param-cleanurls-20260904 · control variant-clean-urls-20260904
 *
 * Las tarjetas de producto enlazaban a /products/x?variant=NNN (metafield
 * custom.variant_url o la variante colocada en la colección). Shopify ya publicaba el
 * canonical limpio, así que el param no aportaba nada a Google y sí restaba: 1.257 URLs
 * con ?variant= acumulan 5.719 impresiones · 75 clics en 90 d (2,6 % de la exposición),
 * duplicando la entidad de la PDP en el índice.
 *
 * El handler deja el href estático (URL limpia = lo único que gatea un bot sin JS) y
 * añade el param en el último instante del click, antes de que el navegador navegue:
 * la PDP sigue aterrizando en la variante correcta. Si el JS no corre (bot, mailto,
 * navegación sin JS) se entra a la PDP con su variante por defecto → cero error.
 */
(function () {
    'use strict';

    document.addEventListener('click', function (event) {
        if (event.defaultPrevented || (event.button !== undefined && event.button !== 0)) { return; }
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) { return; }

        var target = event.target;
        if (!target || typeof target.closest !== 'function') { return; }
        var link = target.closest('a[data-variant-link]');
        if (!link) { return; }

        var variantId = link.getAttribute('data-variant-link');
        var href = link.getAttribute('href') || '';
        if (!variantId || !href || /[?&]variant=/.test(href)) { return; }

        link.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId);
    }, true);
})();



